import React from "react";
import { observer, inject } from "mobx-react";
import GroupSelector from "./_common/group-selector";
import LanguageSwitcher from "./_common/language-switcher";
import * as M from "@material-ui/core";

const SurveyShare = ({ store }) => {
  const { $survey, $group, $locale, $config } = store;
  const [mailTemplate, setMailTemplate] = React.useState("");
  const [shareUrl, setShareUrl] = React.useState("");
  const [mentor, setMentor] = React.useState(false);

  React.useEffect(() => {
    $survey.selected &&
      $survey.selected
        .generateShareUrl($group.selected ? $group.selected._key : null, mentor)
        .then(shortLink => setShareUrl(shortLink));
  }, [$locale.activeLocale, $group.selected, mentor, $survey.selected]);

  return (
    $survey.selected && (
      <div>
        <h3 className="mb-8">Deel de vragenlijst:</h3>

        <M.Box mb={2}>
          <div className="flex justify-between items-center mb-2">
            <GroupSelector label="Voor groep/school:" />
            {$survey.selected.languages.split(",").length > 1 && (
              <LanguageSwitcher languages={$survey.selected.languages.split(",")} />
            )}
          </div>
        </M.Box>

        <React.Fragment>
          {shareUrl ? (
            <React.Fragment>
              {$config.id === "obs-barometer" && (
                <M.FormControlLabel
                  control={
                    <M.Checkbox
                      name="mentor"
                      checked={mentor}
                      onChange={() => setMentor(!mentor)}
                    />
                  }
                  label="De vragenlijst als begeleider invullen"
                />
              )}

              <div className="xl:w-10/12 my-2">
                Als groepsverantwoordelijke kan je onderstaande link gebruiken om:
                <br />- uit te sturen naar de personen die de vragenlijst dienen in te vullen binnen
                je groep
                <br />- om de vragenlijst zelf in te vullen
              </div>

              <div className="flex items-end bg-primary p-4 xl:w-10/12 mb-8">
                <M.TextField fullWidth readOnly value={shareUrl} onFocus={e => e.target.select()} />
              </div>

              {$locale.t($survey.selected._key + "_delen") && (
                <div className="mt-4 lg-col-10">
                  <div className="flex justify-between items-center">
                    <div>Je kan onderstaand mail-sjabloon gebruiken om de link te versturen.</div>
                    {$survey.selected.languages.split(",").length > 1 && (
                      <LanguageSwitcher languages={$survey.selected.languages.split(",")} />
                    )}
                  </div>
                  <M.TextField
                    multiline
                    fullWidth
                    onChange={e => setMailTemplate(e.target.value)}
                    value={
                      mailTemplate ||
                      $locale
                        .t($survey.selected._key + "_delen")
                        .replace("##surveylink##", $survey.selected._shareUrl)
                    }
                  />
                </div>
              )}
            </React.Fragment>
          ) : (
            <div>Een ogenblik ...</div>
          )}
        </React.Fragment>
      </div>
    )
  );
};

export default inject("store")(observer(SurveyShare));
